import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentSingleTabManager,
} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getCookieConsentValue } from "react-cookie-consent";
// add once during startup (e.g., right after initializeApp)
import { getApp } from "firebase/app";
import { getDatabase } from "firebase/database";

import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";

import { ref, set, serverTimestamp } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
console.log("Auth domain in use:", getApp().options.authDomain);
console.log("Page origin:", window.location.origin);
console.log("About to popup with authDomain:", getApp().options.authDomain);
// Initialize Firestore with persistent local cache (once, here)
let db;
const rtdb = getDatabase(app);
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentSingleTabManager(),
    }),
  });
  console.log("[Firestore] persistentLocalCache enabled (single-tab).");
} catch (e) {
  // Fallback if IndexedDB is unavailable (e.g., Safari private mode)
  console.warn("[Firestore] persistentLocalCache unavailable; using memory cache.", e);
  // When initializeFirestore throws due to cache issues, try a plain init:
  db = initializeFirestore(app, {}); // in-memory cache
  
}
export { db, rtdb };
// eslint-disable-next-line no-unused-vars
if (getCookieConsentValue() === "true") {
  getAnalytics(app);
}
const auth = getAuth(app);
export {
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup,
  sendPasswordResetEmail,
};

// Function to log out the user
export const logout = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      const statusRef = ref(rtdb, `/status/${user.uid}`);
      await set(statusRef, {
        state: "offline",
        last_changed: serverTimestamp(),
      });
    }
    await signOut(auth);
  } catch (error) {
    console.error("Logout error:", error);
  }
};
